/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createLightningInvoice} from '../api'

export const useMutationCreateLightningInvoice = createReactQueryMutationHook('createLightningInvoice', createLightningInvoice)
